import { Component, Vue, Prop } from 'vue-property-decorator';
import { PricesTable } from '../ContentDayByDayModule.types';

@Component({
  components: {},
})
export default class HygieneTable extends Vue {
  @Prop({ type: Object as () => PricesTable, default: () => {} })
  readonly item!: PricesTable;
}
